import React from 'react'
import { es } from 'date-fns/locale'
import dayjs from 'dayjs'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import './FilterDocumentsDocuments.css'
import BranchFilter from '../BranchFilter/BranchFilter'
import { useSearchDocumentsVadIvendContext } from 'state/context/SearchDocumentsVadIvendContext'
import {
  regexNT,
  regexPanamaId,
  regexPassport,
  regexRUC,
} from 'Utils/constants'
import { t } from 'i18next'

export default function FilterSearchDocuments() {
  const {
    filters,
    updateFilter,
    applyFilters,
    clearFilters,
    dataWareHouse,
    loadingData,
    setDataWareHouse,
    documentType,
    setErrorFormat,
    errorFormat,
  } = useSearchDocumentsVadIvendContext()

  function handleFilterButton() {
    applyFilters(filters)
  }

  function handleClearFilters() {
    const updateDataWareHouse = dataWareHouse.map(warehouse => ({
      ...warehouse,
      checked: false,
    }))
    setDataWareHouse(updateDataWareHouse)
    clearFilters()
  }

  const filterNames = Object.keys(filters).reduce((acc, key) => {
    acc[key] = key
    return acc
  }, {})

  const validatorFormat = id => {
    const patterns = [regexPanamaId, regexPassport, regexNT, regexRUC]
    return patterns.some(p => p.test(id))
  }

  return (
    <div className="filters-container">
      <div className="input-group">
        <input
          data-testid="input-customername-filter"
          placeholder="Nombre del cliente"
          value={filters?.customerName || ''}
          onChange={e => {
            updateFilter(filterNames.customerName, e.target.value, 'filter')
          }}
        />
      </div>
      <div className="container-document-id">
        <div className="input-group">
          <input
            data-testid="input-customerdoc-filter"
            placeholder="Documento Cliente"
            value={filters?.cedula || ''}
            maxLength={20}
            onChange={event => {
              const validationRegex =
                event.target.value !== ''
                  ? validatorFormat(event.target.value)
                  : true
              setErrorFormat(!validationRegex)
              updateFilter(filterNames.cedula, event.target.value, 'filter')
            }}
          />
        </div>
        {errorFormat && (
          <p className="error">
            {t('DETAIL_DOCUMENTS_T.INTRODUCE_VALID_IDENTIFICATION')}
          </p>
        )}
      </div>
      {documentType === 'CreditNote' ? (
        <div className="input-group">
          <input
            data-testid="input-returnid-filter"
            placeholder="ID Devolución"
            value={filters?.integrationDocumentId || ''}
            onChange={event =>
              updateFilter(
                filterNames.integrationDocumentId,
                event.target.value,
                'filter'
              )
            }
          />
        </div>
      ) : (
        ''
      )}
      <div className="input-group">
        <input
          data-testid="input-documentnumber-filter"
          placeholder="ID Factura"
          value={filters?.documentNumber || ''}
          onChange={event =>
            updateFilter(
              filterNames.documentNumber,
              event.target.value,
              'filter'
            )
          }
        />
      </div>
      <div className="input-group">
        <input
          data-testid="input-purchaseorder-filter"
          placeholder="ID Orden de compra"
          value={filters?.purchaseOrderId || ''}
          onChange={event =>
            updateFilter(
              filterNames.purchaseOrderId,
              event.target.value,
              'filter'
            )
          }
        />
      </div>
      <div className="input-group">
        <BranchFilter
          valueFilter={filters?.branchOffices}
          updateFilter={updateFilter}
          dataWareHouse={dataWareHouse ?? []}
        />
      </div>
      <div className="input-group">
        <input
          data-testid="input-salesperson-filter"
          placeholder="Vendedor"
          value={filters?.salespersonName || ''}
          onChange={event =>
            updateFilter(
              filterNames.salespersonName,
              event.target.value,
              'filter'
            )
          }
        />
      </div>

      <div>
        <LocalizationProvider adapterLocale={es} dateAdapter={AdapterDayjs}>
          <DatePicker
            data-testid="input-datefrom-filter"
            value={
              filters?.initDate
                ? dayjs(filters.initDate, 'YYYY-MM-DD HH:mm:ss')
                : null
            }
            format="DD/MM/YYYY"
            maxDate={dayjs()}
            onChange={newValue => {
              if (newValue) {
                const formattedDate = newValue
                  .startOf('day')
                  .format('YYYY-MM-DD HH:mm:ss')
                updateFilter(filterNames.initDate, formattedDate, 'filter')
              } else {
                updateFilter(filterNames.initDate, null)
              }
            }}
            disableOpenPicker={false}
            slotProps={{
              textField: {
                className: 'custom-datepicker',
                inputProps: {
                  placeholder: 'Fecha del desde',
                  readOnly: true,
                  onKeyDown: e => e.preventDefault(),
                },
              },
            }}
          />
        </LocalizationProvider>
      </div>
      <div>
        <LocalizationProvider adapterLocale={es} dateAdapter={AdapterDayjs}>
          <DatePicker
            data-testid="input-dateto-filter"
            value={
              filters?.endDate
                ? dayjs(filters.endDate, 'YYYY-MM-DD HH:mm:ss')
                : null
            }
            format="DD/MM/YYYY"
            maxDate={dayjs()}
            onChange={newValue => {
              if (newValue) {
                const formattedDate = newValue
                  .endOf('day')
                  .format('YYYY-MM-DD HH:mm:ss')
                updateFilter(filterNames.endDate, formattedDate, 'filter')
              } else {
                updateFilter(filterNames.endDate, null)
              }
            }}
            disableOpenPicker={false}
            slotProps={{
              textField: {
                className: 'custom-datepicker',
                inputProps: {
                  placeholder: 'Fecha hasta',
                  readOnly: true,
                  onKeyDown: e => e.preventDefault(),
                },
              },
            }}
          />
        </LocalizationProvider>
      </div>

      <div className="buttons-container">
        <button
          data-testid="btn-filter-invoices"
          disabled={loadingData}
          onClick={!errorFormat ? handleFilterButton : null}
          className="btn-filter">
          Filtrar
        </button>
        <button
          data-testid="btn-clear-filters-invoices"
          disabled={loadingData}
          onClick={handleClearFilters}
          className="btn-clear">
          Limpiar
        </button>
      </div>
    </div>
  )
}
